import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountStatusService } from '../../providers/account-status.service';
import { faFileInvoiceDollar, faMoneyCheckEdit, faSpinner, faChessKnightAlt, faUser } from '@fortawesome/pro-regular-svg-icons';
import { Horse_show_account_status } from '../../models/accounting/horse_show_account_status';
import { Account_status } from '../../models/accounting/account_status';

import { SmsAbstractAppPage } from '../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-account-statement-list',
  templateUrl: './account-statement-list.component.html',
styleUrls:  ['./account-statement-list.component.css']
})
export class AccountStatementListComponent extends SmsAbstractAppPage implements OnInit {

faFileInvoiceDollar = faFileInvoiceDollar;
faMoneyCheckEdit = faMoneyCheckEdit;
faSpinner = faSpinner;
faChessKnightAlt = faChessKnightAlt;
faUser = faUser;

loading_in_progress: boolean = false;
//An empty list means nothing until the request it came from has finished.
list_loaded: boolean = false;
horse_show_accounts: Horse_show_account_status[] = [];

/**
 * Paged a show at a time, the way MY ENTRIES pages. The difference is where the
 * slicing happens: MY ENTRIES asks the ecommerce API for one page at a time,
 * while this endpoint has no limit/offset and answers with the user's whole
 * list, so the page is taken here. Every show the user can see is already in
 * horse_show_accounts - paging only governs how many are on screen at once.
 */
page: number = 1;
pageSize: number = 10;
visible_horse_show_accounts: Horse_show_account_status[] = [];

  constructor(private accountStatusService:AccountStatusService,
    private route: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {

            if(params['cached']){
              this.horse_show_accounts = this.accountStatusService.getCachedList();
              this.showPage(1);
              this.list_loaded = true;
            } else {
              this.loading_in_progress = true;
              this.accountStatusService.getUserList().then(account_list => {
                this.horse_show_accounts = account_list;
                this.showPage(1);
                this.list_loaded = true;
                this.loading_in_progress = false;
              }).catch(error => {
                this.handleError(error);
                this.loading_in_progress = false;
              });
            }

        });
  }

  pageChanged(page: number): void {
    this.showPage(page);
  }

  private showPage(page: number): void {
    this.page = page;
    const first = (page - 1) * this.pageSize;
    this.visible_horse_show_accounts = this.horse_show_accounts.slice(first, first + this.pageSize);
  }

  viewStatement(account: Account_status): void {
    this.router.navigate(['account-statements/view', account.entry_id]);
  }

  goToCheckOut(account: Account_status): void {
    this.router.navigate(['check-out/check-out-list', account.horse_show_id]);
  }

}
